export default "__VITE_ASSET__DTC4pObA__"